/**
 * MetaMask's injected inpage.js sometimes rejects promises while "restoring session"
 * before any app code runs. That triggers "Uncaught (in promise)" and CRA's red overlay
 * even though we never called the wallet. Mark those rejections as handled so the UI stays clean.
 */
function flattenReasonChain(reason, depth = 0) {
  if (depth > 8) return "";
  if (reason == null) return "";
  const parts = [
    typeof reason === "string" ? reason : String(reason?.message ?? ""),
    String(reason?.stack ?? ""),
  ];
  if (reason?.cause) parts.push(flattenReasonChain(reason.cause, depth + 1));
  return parts.join("\n");
}

function isWalletInjectionUnhandledNoise(reason) {
  const text = flattenReasonChain(reason);
  if (!text) return false;
  if (/failed to connect to metamask/i.test(text)) return true;
  if (/meta\s*mask extension not found/i.test(text)) return true;
  if (/error restoring session/i.test(text)) return true;
  if (/scripts\/inpage\.js/i.test(text) && /nkbihfbeogaeaoehlefnkodbefgpgknn/i.test(text)) return true;
  return false;
}

export function installWalletExtensionNoiseHandlers() {
  if (typeof window === "undefined") return () => {};

  const onUnhandledRejection = (e) => {
    if (isWalletInjectionUnhandledNoise(e.reason)) {
      e.preventDefault();
    }
  };

  const onError = (e) => {
    const err = e?.error;
    const text = [
      String(e?.message ?? ""),
      String(e?.filename ?? ""),
      flattenReasonChain(err),
    ].join("\n");
    if (
      /inpage\.js/i.test(text) &&
      (/nkbihfbeogaeaoehlefnkodbefgpgknn/i.test(text) ||
        /failed to connect to metamask|extension not found|restoring session/i.test(text))
    ) {
      e.preventDefault?.();
    }
  };

  window.addEventListener("unhandledrejection", onUnhandledRejection);
  window.addEventListener("error", onError, true);

  return () => {
    window.removeEventListener("unhandledrejection", onUnhandledRejection);
    window.removeEventListener("error", onError, true);
  };
}
